import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'app-goal-progress-bar',
  styleUrl: './goal-progress-bar.component.scss',
  templateUrl: './goal-progress-bar.component.html',
})
export class GoalProgressBarComponent {
  readonly progress: InputSignal<number> = input.required<number>();
  readonly totalDistance: InputSignal<number> = input.required<number>();
  readonly currentDistance: InputSignal<number> = input.required<number>();
  readonly nbParticipants: InputSignal<number> = input.required<number>();
  readonly isAstraZeneca: InputSignal<boolean> = input.required<boolean>();

  readonly progressValue: Signal<number> = computed<number>(() => {
    return Math.min(100, Math.max(0, this.progress()));
  });
}
